export enum RecipientType {
    TO = 1,
    CC = 2,
    BCC = 3,
}

export enum DueDiligenceEmailType {
  ClientSubmissionAdjusted,
  ClientSubmissionUpToDate,
}